import { NavigationItem } from "@/interfaces/NavigationItem";
import { RouteNamesEnum } from "./routes";

export const appNav: NavigationItem[] = [
  {
    name: 'Jobs Posted',
    icon: 'assets/icon/list.svg',
    route: RouteNamesEnum.JobsPosted,
    url: 'jobs-posted'
  },
  {
    name: 'add',
    icon: 'assets/icon/plus.svg',
    route: RouteNamesEnum.PostJobChoose,
    isMainButton: true,
    url: 'post-job-choose'
  },
  {
    name: 'My Work',
    route: RouteNamesEnum.MyWork,
    icon: 'assets/icon/delivery.svg',
    url: 'my-work'
  },
  {
    name: 'Browse Jobs',
    route: RouteNamesEnum.BrowseJobs,
    icon: 'assets/icon/search-delivery.svg',
    url: 'browse-jobs'
  }
];
